import styled from 'styled-components';

export const Container = styled.div``;

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--s5);
`;

/*
 * The design's `.actionbar`, standing on its own because the two things it
 * commits live in two sibling cards. It carries the card's ground and rule so
 * it still reads as the foot of the stack rather than as a loose button.
 */
export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--s2);
  margin-top: var(--s5);
  padding: var(--s4) var(--s5);
  background: var(--surface-alt);
  border: 1px solid var(--line);
  border-radius: var(--r-md);
`;
